<template>
    <span class="label" :class="getLabelTheme(category.slug)">{{ category.cat_name }}</span>
</template>

<script>
export default {
    name: "label-theme",
    props: ['category'],
    methods: {
        getLabelTheme(slug) {
            let label = '';

            switch (slug) {
                case 'new':
                    label = 'label--blue'
                    break;
                case 'updates':
                    label = 'label--blue'
                    break;
                case 'press':
                    label = 'label--mustard'
                    break;
                case 'press-release':
                    label = 'label--green'
                    break;
                case 'insight' :
                    label = 'label--black'
                    break;
                default:
                    label = 'label--black'
                    break;
            }

            return label;
        },
    },
}
</script>